import { Box, Button, Panel } from '@hover/blueprint';
import React from 'react';
import styled from 'styled-components';

import { PillList } from '../PillList';

interface Item {
  color: string;
  name: string;
}

interface ColorPalletProps {
  items: Item[];
  selectedColor?: string;
  selectedGroup: string;
  onPress: (color: string) => void;
}

interface ColorPickerProps {
  items: Item[];
  title: string;
  groups: string[];
  selectedColor: string;
  selectedGroup: string;
  setColorGroup: (group: string) => void;
  changeColor: (color: string) => void;
}

interface ColorBtnProps {
  backgroundColor: string;
  isSelected: boolean;
}

const ColorButton = styled(Button)<ColorBtnProps>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 0;

  &:hover:not([disabled]),
  &:active:not([disabled]) {
    background-color: ${({ backgroundColor }) => backgroundColor};
  }

  &::after {
    position: absolute;
    display: ${({ isSelected }) => (isSelected ? 'block' : 'none')};
    content: '';
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #fff;
  }
`;

const ColorPallet = ({
  items,
  selectedColor,
  onPress,
  selectedGroup,
}: ColorPalletProps) => (
  <Panel
    borderColor="neutral200"
    borderStyle="solid"
    borderWidth="2px"
    display="grid"
    gridArea={0}
    gridColumnGap={50}
    gridRowGap={50}
    gridTemplateColumns="auto auto auto auto auto"
    margin={0}
    padding={50}
  >
    {items.map(item => (
      <ColorButton
        backgroundColor={item.color}
        fill="minimal"
        height="50px"
        isSelected={item.color === selectedColor}
        key={`${selectedGroup}-${item.color}`}
        label={item.name}
        onPress={() => onPress(item.color)}
      />
    ))}
  </Panel>
);

const ColorPicker = ({
  title,
  items,
  groups,
  selectedColor,
  selectedGroup,
  setColorGroup,
  changeColor,
}: ColorPickerProps) => (
  <Box display="block" flexDirection="column" marginBottom={600}>
    <PillList
      items={groups}
      marginBottom={0}
      onPress={setColorGroup}
      selected={selectedGroup}
      title={title}
    />
    <ColorPallet
      items={items}
      onPress={changeColor}
      selectedColor={selectedColor}
      selectedGroup={selectedGroup}
    />
  </Box>
);

export { ColorPicker };
